import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { ADMIN_ROLES, STAFF_ROLES } from '../redux/selectors';

const AdminRoutes = ({ user }) => {
  const { pathname } = useLocation();
  if (!user.isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  // Invoice notifications for owners lead to the scoped Clients review and
  // invoice-detail workflow. Do not grant these roles the rest of the admin tree.
  const ownerBillingRoute =
    ['Owner', 'Store Owner'].includes(user.role) &&
    (pathname === '/clients' || /^\/invoices\/[1-9]\d*$/.test(pathname));
  if (!ADMIN_ROLES.includes(user.role) && !STAFF_ROLES.includes(user.role) && !ownerBillingRoute) {
    return <Navigate to="/client/dashboard" replace />;
  }
  return <Outlet />;
};

export default AdminRoutes;
